import React, { useRef } from 'react';
import Slider from 'react-slick';
import { motion } from 'framer-motion';
import { HiOutlineArrowNarrowRight, HiOutlineArrowNarrowLeft } from 'react-icons/hi';
import { IoIosCall } from 'react-icons/io';
import { BsArrowRight } from 'react-icons/bs';

import callNowImg from '../../assets/images/callnow.png';
import installImg from '../../assets/images/trust01.jpg';
import repairImg from '../../assets/images/about_img01.jpg';
import replaceImg from '../../assets/images/welcome-02.jpg';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './Solutions.css';

function Solutions() {
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ]
  };

  return (
    <section className="solutions" id="Solutions">
      <div className="container">
        
        {/* ── Mockup-Exact Header ── */}
        <div className="solutions__header">
          <div className="solutions__header-left">
            <p className="solutions__subtitle">
              From brand-new roof installations to rapid emergency repairs, our 
              expert team delivers top-quality craftsmanship and lasting protection to 
              keep your home secure and stylish in any situation.
            </p>
          </div>
          <div className="solutions__header-right">
            <div className="solutions__title-area">
              <h2 className="solutions__title">
                Durable, Stylish <br /> <span>Roofing Solutions</span>
              </h2>
              <div className="solutions__nav">
                <button onClick={() => sliderRef.current.slickPrev()} className="nav-btn"><HiOutlineArrowNarrowLeft /></button>
                <button onClick={() => sliderRef.current.slickNext()} className="nav-btn nav-btn--active"><HiOutlineArrowNarrowRight /></button>
              </div>
            </div>
          </div>
        </div>

        {/* ── Carousel Grid ── */}
        <div className="solutions__carousel">
          <Slider ref={sliderRef} {...settings}>
            
            {/* Card 1: Call Now (Person Focus) */}
            <div className="solutions__slide">
              <div className="card-call">
                <div className="card-call__content">
                  <span className="card-call__label">Call Now</span>
                  <div className="card-call__image">
                    <img src={callNowImg} alt="Call Center" />
                    <a href="tel:+94763607727" className="card-call__cta-btn">
                      <IoIosCall /> +94 76 360 7727
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 2: New Roof */}
            <ServiceCard 
              title="New Roof Installation"
              desc="Complete roof overhaul for renewed protection and aesthetic upgrade."
              image={installImg}
            />

            {/* Card 3: Expert Repair */}
            <ServiceCard 
              title="Expert Roof Repairs"
              desc="Complete roof overhaul for renewed protection and aesthetic upgrade."
              image={repairImg}
            />

            {/* Card 4: Replacement */}
            <ServiceCard 
              title="Full Roof Replacement"
              desc="Complete roof overhaul for renewed protection and aesthetic upgrade."
              image={replaceImg}
            />
            {/* Card 4: Replacement */}
            <ServiceCard 
              title="Full Roof Replacement"
              desc="Complete roof overhaul for renewed protection and aesthetic upgrade."
              image={replaceImg}
            />

          </Slider>
        </div>

      </div>
    </section>
  );
}

const ServiceCard = ({ title, desc, image }) => (
  <div className="solutions__slide">
    <div className="card-service">
      <div className="card-service__content">
        <h3 className="card-service__title">{title}</h3>
        <p className="card-service__desc">{desc}</p>
        <div className="card-service__image-container">
          <img src={image} alt={title} />
          <button className="card-service__icon-btn">
            <BsArrowRight />
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default Solutions;
